export function isSrcInvalid(src: string | undefined | null) {
  return src === undefined || src === null || src === '' || src.split('?')[0].trim() === ''
}
